var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterMobileSingleReply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.633 7.11q0-2.412-1.665-4.067T10.89 1.388l-3.78-.021q-2.413 0-4.078 1.665T1.367 7.068 3 10.954q1.633 1.515 4.132 1.516h.363q.277 0 .48.203a.66.66 0 0 1 .203.48v2.904q5.125-3.352 6.181-4.25a6.5 6.5 0 0 0 1.666-2.145 5.8 5.8 0 0 0 .608-2.552m1.367 0v.022a7.06 7.06 0 0 1-.737 3.117q-.736 1.516-2.199 2.755-1.462 1.237-7.206 4.89a.86.86 0 0 1-.46.106.48.48 0 0 1-.437-.246q-.15-.245-.15-.437v-3.48q-2.925-.107-4.868-2.018Q0 9.907 0 7.014T2.06 2.06Q4.12 0 7.11 0l3.78.021q2.99 0 5.05 2.05T18 7.111"
})));
export default SvgTwitterMobileSingleReply;